export default {
  GRANTED: "granted",
}
